import React, { useState, useEffect } from 'react';

const TaskSummary = ({ className = '' }) => {
    const [taskSummary, setTaskSummary] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchTaskSummary = async () => {
            try {
                setLoading(true);
                setError(null);
                console.log('Fetching task summary...');
                const response = await fetch(`${process.env.REACT_APP_API_URL}/api/todo/summary`);
                if (response.ok) {
                    const data = await response.json();
                    console.log('Task summary data:', data);
                    setTaskSummary(data);
                } else {
                    console.error('Failed to fetch task summary:', response.statusText);
                    setError('Failed to fetch task summary');
                }
            } catch (error) {
                console.error('Error fetching task summary:', error);
                setError(error.message || 'Error fetching task summary');
            } finally {
                setLoading(false);
            }
        };

        fetchTaskSummary();
        // Set up polling to refresh summary every 30 seconds
        const interval = setInterval(fetchTaskSummary, 30000);
        return () => clearInterval(interval);
    }, []);

    const getStatusColor = (status) => {
        switch (status) {
            case 'Not Started':
                return 'bg-gray-100';
            case 'Started':
                return 'bg-yellow-100';
            case 'In-Progress':
                return 'bg-blue-100';
            case 'Complete':
                return 'bg-green-100';
            default:
                return 'bg-gray-100';
        }
    };

    if (loading) {
        return (
            <div className={`grid grid-cols-1 md:grid-cols-4 gap-4 ${className}`}>
                {[...Array(4)].map((_, index) => (
                    <div key={index} className="animate-pulse bg-gray-100 p-4 rounded-lg border shadow-sm">
                        <div className="h-6 bg-gray-200 rounded w-3/4 mb-2"></div>
                        <div className="h-8 bg-gray-200 rounded w-1/2 mb-2"></div>
                        <div className="space-y-1">
                            <div className="h-4 bg-gray-200 rounded w-1/3"></div>
                            <div className="h-4 bg-gray-200 rounded w-1/3"></div>
                            <div className="h-4 bg-gray-200 rounded w-1/3"></div>
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    if (error) {
        return (
            <div className={`bg-red-50 border border-red-200 text-red-700 p-4 rounded-lg ${className}`}>
                {error}
            </div>
        );
    }

    return (
        <div className={`grid grid-cols-1 md:grid-cols-4 gap-4 ${className}`}>
            {taskSummary.map((summary) => (
                <div
                    key={summary.status}
                    className={`${getStatusColor(summary.status)} p-4 rounded-lg border shadow-sm`}
                >
                    <h3 className="text-lg font-semibold mb-2">{summary.status} : {summary.total_count}</h3>
                    <div className="space-y-2">
                        <div className="text-sm space-y-1">
                            <p className="text-red-600">High: {summary.high_priority_count}</p>
                            <p className="text-yellow-600">Medium: {summary.medium_priority_count}</p>
                            <p className="text-green-600">Low: {summary.low_priority_count}</p>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default TaskSummary;
